import { Controller } from 'react-hook-form';
import { Radio, RadioGroup } from '@ds';
import { AdminFormRow } from '@ui';
import { AffiliationType, LocationPreference } from '@/api/apis/resources';
import { useLocationPreference } from './useLocationPreference';

type LocationPreferenceSelectorProps = {
  isReadOnly?: boolean;
  isContractor?: boolean;
};

export const LocationPreferenceSelector = ({ isReadOnly, isContractor }: LocationPreferenceSelectorProps) => {
  const { control, affiliationType, locationPreferences, getAffiliationLabel } = useLocationPreference({
    isContractor,
  });

  return (
    <AdminFormRow title="Location Preferences" isRequired>
      <Controller
        name="locationPreference"
        control={control}
        render={({ field: { value, onChange, ...field }, fieldState: { invalid, error } }) => (
          <RadioGroup
            className="gap-8"
            orientation="horizontal"
            value={value}
            isInvalid={invalid}
            errorMessage={error?.message}
            onValueChange={(newValue) => {
              onChange(newValue);
            }}
            {...field}
          >
            {locationPreferences.map((location) => {
              if (
                isContractor &&
                location.value === LocationPreference.Affiliation &&
                affiliationType !== AffiliationType.TXCenter &&
                affiliationType !== AffiliationType.OPO
              ) {
                return null;
              }

              const label =
                isContractor && location.value === LocationPreference.Affiliation
                  ? getAffiliationLabel()
                  : location.name;

              return (
                <Radio
                  isDisabled={isReadOnly}
                  className="w-25 max-w-none"
                  key={location.value}
                  value={location.value}
                  size="lg"
                >
                  {label}
                </Radio>
              );
            })}
          </RadioGroup>
        )}
      />
    </AdminFormRow>
  );
};
